export default "__VITE_ASSET__Dk6jvnr5__"